var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCaretRight = function SvgCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 17,
    fill: "none",
    viewBox: "0 0 10 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m2 2 5.88 6.352a.45.45 0 0 1 .12.314.48.48 0 0 1-.12.314L2 15.333"
  })));
};
export { SvgCaretRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxMCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMS45OTk2OEw3Ljg3OTQ3IDguMzUyMjdDNy45MTc2OCA4LjM5MzQ5IDcuOTQ3OTkgOC40NDI0NSA3Ljk2ODY3IDguNDk2MzRDNy45ODkzNiA4LjU1MDIzIDggOC42MDggOCA4LjY2NjM0QzggOC43MjQ2OCA3Ljk4OTM2IDguNzgyNDUgNy45Njg2NyA4LjgzNjM0QzcuOTQ3OTkgOC44OTAyNCA3LjkxNzY4IDguOTM5MTkgNy44Nzk0NyA4Ljk4MDQyTDIgMTUuMzMzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";